module.exports = __webpack_public_path__ + "static/media/23-9.f50072aa.mp3";